<template>
  <div class="home">
    <!-- The video -->
    <img class="logo" src="../assets/scene-of-sound-logo.png"/>
    <div class="overlay"></div>
<!--    <video autoplay muted loop id="myVideo">-->
<!--      <source src="../assets/sos-background.mp4" type="video/mp4">-->
<!--    </video>-->
    <div class="gifBg"></div>
    <HelloWorld msg="Oh YEa video time"></HelloWorld>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>

<style scoped lang="scss">
  /* Style the video: 100% width and height to cover the entire window */
  /*#myVideo {*/
  /*  position: fixed;*/
  /*  left: 0;*/
  /*  top: 0;*/
  /*  bottom: 0;*/
  /*  right: 0;*/
  /*  min-width: 100%;*/
  /*  min-height: 100%;*/
  /*}*/

  .gifBg {
    background-image: url('../assets/sos-background.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    left: 0;
    top: 0;
    min-width: 100%;
    min-height: 100%;
  }

  .logo{
    position: relative;
    min-width: 100px;
    max-width: 300px;
    margin: auto;
    padding: 0 0 0 30px;
    z-index: 10;
  }

  .overlay {
    background-color: rgba(0,0,0,0.9);
    position: fixed;
    min-height: 100%;
    min-width: 100%;
    bottom: 0;
    left:0;
    right: 0;
    top: 0;
    z-index: 2;
  }

</style>
